// extracted by mini-css-extract-plugin
export var active = "_2u-9";
export var backButton = "_2u-8";
export var clone = "_2u-e";
export var collapseBar = "_2u-k";
export var collapseMode = "_2u-m";
export var collapsed = "_2u-o";
export var dimmed = "_2u-i";
export var dragHandle = "_2u-c";
export var dropdownIcon = "_2u-g";
export var expanding = "_2u-n";
export var hidden = "_2u-x";
export var iconContainer = "_2u-q";
export var iconSwapper = "_2u-w";
export var navItem = "_2u-6";
export var navItemIcon = "_2u-f";
export var navProfile = "_2u-7";
export var notificationCountBadge = "_2u-j";
export var notificationDot = "_2u-r";
export var optionsContainer = "_2u-h";
export var primaryNav = "_2u-0";
export var primaryNavDivider = "_2u-v";
export var primaryNavResizeHandle = "_2u-2";
export var primaryNavResizing = "_2u-1";
export var primaryNavTabSection = "_2u-u";
export var primaryTab = "_2u-p";
export var primaryTabIconBox = "_2u-s";
export var secondaryNav = "_2u-3";
export var selected = "_2u-t";
export var settingsNav = "_2u-4";
export var settingsNavItems = "_2u-5";
export var show = "_2u-d";
export var sideNav = "_2u-l";
export var teamItem = "_2u-a";
export var userProfileItem = "_2u-b";